<div class="forgotPassMainContainer">
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="forgotBlock">
        <img src="assets/logo.svg" width="200px" draggable="false" />
        <input
            type="text"
            id="email"
            [placeholder]="'auth.forgotPassword.email' | translate"
            formControlName="email"
            class="form-control"
            aria-label="Small"
            aria-describedby="inputGroup-sizing-sm"
            autocomplete="email"
        />
        <button
            type="submit"
            class="validateButton"
            [disabled]="resetForm.invalid"
        >
            {{ "auth.forgotPassword.sendButton" | translate }}
        </button>
        <div>
            <a [routerLink]="['/login']">{{
                "auth.forgotPassword.backToLogin" | translate
            }}</a>
        </div>
    </form>
</div>
